import { createSelector } from 'reselect';
import type { RootState } from 'typesafe-actions';

import type { SeoState } from './reducer';

export const getSeo = (state: RootState) => state.seo;
export const getSEOData = createSelector(getSeo, (state: SeoState) => state.data);

export const getDataLayer = createSelector(getSeo, (state: SeoState) => state.dataLayer);
